// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationBankSource,
  unionToSimulationBankSource,
  unionListToSimulationBankSource,
} from "./simulation-bank-source";
import {
  SimulationCaptureReplay,
  SimulationCaptureReplayT,
  verifySimulationCaptureReplay,
} from "./simulation-capture-replay";
import {
  SimulationOpcUaScript,
  SimulationOpcUaScriptT,
  verifySimulationOpcUaScript,
} from "./simulation-opc-ua-script";
import { AdapterProtocol } from "../archive/adapter-protocol";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * One bank a scenario drives.
 */
export class SimulationScenarioBank implements flatbuffers.IUnpackableObject<SimulationScenarioBankT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationScenarioBank {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationScenarioBank(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationScenarioBank,
  ): SimulationScenarioBank {
    return (obj || new SimulationScenarioBank()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationScenarioBank(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationScenarioBank,
  ): SimulationScenarioBank {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationScenarioBank()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Display name, copied when the bank is added.
   */
  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  protocol(): AdapterProtocol {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterProtocol.MCE;
  }

  /**
   * The address VTS dials for this bank: the channel's vendor socket
   * address ("ip:port") or OPC UA endpoint URL.
   */
  vendorAddress(): string;
  vendorAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  vendorAddress(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  sourceType(): SimulationBankSource {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SimulationBankSource.NONE;
  }

  source<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  enabled(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  static startSimulationScenarioBank(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankIdOffset, 0);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankNameOffset, 0);
  }

  static addProtocol(builder: flatbuffers.Builder, protocol: AdapterProtocol) {
    builder.addFieldInt8(2, protocol, AdapterProtocol.MCE);
  }

  static addVendorAddress(builder: flatbuffers.Builder, vendorAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, vendorAddressOffset, 0);
  }

  static addSourceType(builder: flatbuffers.Builder, sourceType: SimulationBankSource) {
    builder.addFieldInt8(4, sourceType, SimulationBankSource.NONE);
  }

  static addSource(builder: flatbuffers.Builder, sourceOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, sourceOffset, 0);
  }

  static addEnabled(builder: flatbuffers.Builder, enabled: boolean) {
    builder.addFieldInt8(6, +enabled, +true);
  }

  static endSimulationScenarioBank(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // bank_id
    builder.requiredField(offset, 10); // vendor_address
    builder.requiredField(offset, 14); // source
    return offset;
  }

  static createSimulationScenarioBank(
    builder: flatbuffers.Builder,
    bankIdOffset: flatbuffers.Offset,
    bankNameOffset: flatbuffers.Offset,
    protocol: AdapterProtocol,
    vendorAddressOffset: flatbuffers.Offset,
    sourceType: SimulationBankSource,
    sourceOffset: flatbuffers.Offset,
    enabled: boolean,
  ): flatbuffers.Offset {
    SimulationScenarioBank.startSimulationScenarioBank(builder);
    SimulationScenarioBank.addBankId(builder, bankIdOffset);
    SimulationScenarioBank.addBankName(builder, bankNameOffset);
    SimulationScenarioBank.addProtocol(builder, protocol);
    SimulationScenarioBank.addVendorAddress(builder, vendorAddressOffset);
    SimulationScenarioBank.addSourceType(builder, sourceType);
    SimulationScenarioBank.addSource(builder, sourceOffset);
    SimulationScenarioBank.addEnabled(builder, enabled);
    return SimulationScenarioBank.endSimulationScenarioBank(builder);
  }

  unpack(): SimulationScenarioBankT {
    return new SimulationScenarioBankT(
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.bankName(),
      this.protocol(),
      this.vendorAddress(),
      this.sourceType(),
      (() => {
        const temp = unionToSimulationBankSource(this.sourceType(), this.source.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.enabled(),
    );
  }

  unpackTo(_o: SimulationScenarioBankT): void {
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.bankName = this.bankName();
    _o.protocol = this.protocol();
    _o.vendorAddress = this.vendorAddress();
    _o.sourceType = this.sourceType();
    _o.source = (() => {
      const temp = unionToSimulationBankSource(this.sourceType(), this.source.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.enabled = this.enabled();
  }

  unpackFields(...fields: string[]): SimulationScenarioBankT {
    const t = new SimulationScenarioBankT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("protocol")) {
      t.protocol = this.protocol();
    }
    if (fieldSet.has("vendor_address")) {
      t.vendorAddress = this.vendorAddress();
    }
    if (fieldSet.has("source_type")) {
      t.sourceType = this.sourceType();
    }
    if (fieldSet.has("source")) {
      t.source = (() => {
        const temp = unionToSimulationBankSource(this.sourceType(), this.source.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("enabled")) {
      t.enabled = this.enabled();
    }
    return t;
  }
}

export class SimulationScenarioBankT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankId: UuidT | null = null,
    public bankName: string | Uint8Array | null = null,
    public protocol: AdapterProtocol = AdapterProtocol.MCE,
    public vendorAddress: string | Uint8Array | null = null,
    public sourceType: SimulationBankSource = SimulationBankSource.NONE,
    public source: SimulationCaptureReplayT | SimulationOpcUaScriptT | null = null,
    public enabled: boolean = true,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.vendorAddress === null || this.vendorAddress === undefined) {
      throw new Error('Required field "vendor_address" is not set');
    }
    if (this.source === null || this.source === undefined) {
      throw new Error('Required field "source" is not set');
    }
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const vendorAddress =
      this.vendorAddress !== null ? builder.createString(this.vendorAddress!) : 0;
    const source = builder.createObjectOffset(this.source);

    return SimulationScenarioBank.createSimulationScenarioBank(
      builder,
      bankId,
      bankName,
      this.protocol,
      vendorAddress,
      this.sourceType,
      source,
      this.enabled,
    );
  }

  clone(): SimulationScenarioBankT {
    const obj = new SimulationScenarioBankT();
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.bankName = this.bankName;
    obj.protocol = this.protocol;
    obj.vendorAddress = this.vendorAddress;
    obj.sourceType = this.sourceType;
    obj.source =
      this.source !== null && typeof (this.source as any).clone === "function"
        ? (this.source as any).clone()
        : this.source;
    obj.enabled = this.enabled;
    return obj;
  }

  equals(other: SimulationScenarioBankT): boolean {
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.bankName !== other.bankName) return false;
    if (this.protocol !== other.protocol) return false;
    if (this.vendorAddress !== other.vendorAddress) return false;
    if (this.sourceType !== other.sourceType) return false;
    if (this.source !== null && other.source !== null) {
      if (typeof (this.source as any).equals === "function") {
        if (!(this.source as any).equals(other.source)) return false;
      } else if (this.source !== other.source) return false;
    } else if (this.source !== other.source) return false;
    if (this.enabled !== other.enabled) return false;
    return true;
  }
}

export function verifySimulationScenarioBank(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "bank_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "vendor_address");
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkUnionConsistency(tablePos, 12, 14, "source");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 12);
        switch (uType) {
          case 1: // SimulationCaptureReplay
            {
              const o = verifier.readInt32(pos);
              verifySimulationCaptureReplay(verifier, pos + o);
            }
            break;
          case 2: // SimulationOpcUaScript
            {
              const o = verifier.readInt32(pos);
              verifySimulationOpcUaScript(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 14, "source");
    verifier.checkScalarField(tablePos, 16, 1);
  } finally {
    verifier.popDepth();
  }
}
